const resLabels = {
  id: "Quote Price ID",
  quoteType: "Quote Type",
  approvedByCustomer: "Approved by Customer",
  approvedByVendor: "Approved by Vendor",
  noBidReason: "No Bid Reason",
  description: "Internal Description",
  customerDescription: "Customer Description",
  vendorDescription: "Vendor Description",
  localContactName: "Local Contact Name",
  localContactNumber: "Local Contact Number",
  quoteReqId: "Quote Request ID",
  priceId: "Price ID",
  quoteId: "Quote ID",
  raiting: "Rating",
  createdAt: "Created At",
  status: "Status",
  type: "Type",
  multiQuoteId: "Multi Quote ID",
  addressAId: "Address A ID",
  addressBId: "Address B ID",
  endCustomerName: "End Customer Name",
  customerProjectNumber: "Customer Project Number",
  customerName: "Customer Name",
  userName: "User Name",
  RFSdate: "Ready for Service Date",
  contractTerm: "Contract Term (Months)",
  dueDate: "Due Date",
  initiatorId: "Initiator ID",
  implementerId: "Implementer ID",
  quoteGroupId: "Quote Group ID",
  source: "Source",
  quoteWonAt: "Quote Won At",
  updatedAt: "Updated At",
  locationId: "Location ID",
  buildingNumber: "Building Number",
  street: "Street",
  city: "City",
  state: "State",
  zipCode: "Zip Code",
  isValidate: "Is Validated",
  country: "Country",
  lat: "Latitude",
  long: "Longitude",
  billing_address: "Billing Address",
  companyName: "Company Name",
  companyType: "Company Type",
  accountType: "Account Type",
  currency: "Currency",
  nda: "NDA",
  msa: "MSA",
  registered_address: "Registered Address",
  website: "Website",
  uploadetAt: "Uploaded At",
  performanceRating: "Performance Rating",
  salesforceId: "Salesforce ID",
  isManual: "Is Manual Entry",
  vendorName: "Vendor Name",
  vendorProductName: "Vendor Product Name",
  airxProductName: "Airx Product Name",
  lastMileProvider: "Last Mile Provider",
  bandWidth: "Bandwidth (Mbps)",
  targetMRC: "Target MRC",
  targetOTC: "Target OTC",
  targetCurrency: "Target Currency",
  CPE: "CPE Included",
  OTE: "OTE",
  MRE: "MRE",
  isLocalTax: "Local Tax/VAT*",
  localTax: "Local Tax (%)",
  interface: "Interface",
  leadTeam: "Lead Time",
  SlaUptime: "SLA Uptime (%)",
  SlaMTTR: "SLA MTTR (Hours)",
  userId: "User ID",
  cableProvider: "Cable Provider",
  companyId: "Company ID",
  DcServiceType: "Type",
  dataLimitType: "Data Limit Type",
  dutiesIncluded: "Duties Included",
  hoursType: "Hours Type",
  licenseStatus: "License Status",
  maintenanceSla: "Maintenance SLA",
  maintenanceStatus: "Maintenance Status",
  maintenanceType: "Maintenance Type",
  onSiteDeliveryIncluded: "On-Site Delivery Included",
  onSiteInstallationIncluded: "On-Site Installation Included",
  rackSize: "Rack Size",
  IP: "IP",
  downloadSpeed: "Download Speed",
  purchaseType: "Purchase Type",
  uploadSpeed: "Upload Speed",
  AccessTechnology: "Access Technology",
  priceCode: "Price Code",
  networkStatus: "Network Status",
  dataLimitGB: "Data Limit GB",
  extraHoursRate: "Extra Hours Rate",
  fieldServiceType: "Field Service Type",
  jumboFrames: "Jumbo Frames",
  licenseName: "License Name",
  manufaturerName: "Manufacturer Name",
  mtuSize: "MTU Size",
  noOfHours: "Number of Hours",
  overageCharges: "Overage Charges",
  perMbRate: "Per MB Rate",
  power: "Power",
  productCode: "Product Code",
  provider: "Provider",
  qinqSupported: "QinQ Supported",
  quantity: "Quantity",
  slaLatency: "SLA Latency",
  spaceSize: "Space Size",
  ipRange: "IP Range",
};
export default resLabels;
